<template>
  <div class="login-page theme-audra">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-md-8">
          <div class="card login-box position-relative">
            <div class="overlay text-center" v-if="is_loading">
              <img src="/assets/images/loader.svg" alt="" />
            </div>
            <div>
              <img :src="getImage('logo.svg')" alt="Dotlines" />
              <form
                @submit.prevent="submit_otp()"
                method="POST"
                class="response-alert"
                novalidate
              >
                <div class="form-group mb-3">
                  <label class="control-label">OTP Code</label>
                  <input
                    type="text"
                    name="otp_code"
                    v-model.trim="user.otp_code"
                    class="form-control"
                    placeholder="Reset OTP Code"
                    v-validate="'required'"
                    :class="{ 'has-error': errors.has('otp_code') }"
                  />

                  <div class="help text-danger" v-show="errors.has('otp_code')">
                    {{ errors.first("otp_code") }}
                  </div>
                </div>
                <button type="submit" class="btn btn-common btn-block mb-4">
                  Submit OTP
                </button>

                <div class="text-center">
                  <router-link
                    class="pc fw-500 align-items-center d-inline-flex"
                    :to="{ name: 'Login' }"
                  >
                    <i style="font-size: 24px" class="icon-arrow-left-circle mr-2"></i>
                    Back to login
                  </router-link>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-md-4 ml-auto d-none d-sm-block">
          <div class="login-img">
            <h2><span>Enterprise</span> Grade Internet <strong>Security</strong>.</h2>
            <img class="like" src="/assets/images/like.png" alt="like" />
            <img class="sheild" src="/assets/images/sheild.png" alt="sheild" />
            <img class="wifi" src="/assets/images/wifi.png" alt="wifi" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GuestLayout from "@/components/layouts/GuestLayoutComponent.vue";
import router from "@/router";
import axios from "axios";
import LocalStorage from "@/services/localStorage";
import { mapActions } from "vuex";
// import store from "@/store";

export default {
  components: {
    //
  },
  data: () => ({
    user: {
      otp_code: "",
    },
    is_loading: false,
  }),
  methods: {
    ...mapActions(["LOGIN_AUDRA_DEVICE_FIRSTTIME_OTP_CONFIRM"]),
    submit_otp: function (e) {
      const _this = this;
      _this.is_loading = true;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this
            .LOGIN_AUDRA_DEVICE_FIRSTTIME_OTP_CONFIRM(_this.user)
            .then((response) => {
              axios.defaults.baseURL = LocalStorage.get("baseAPIURL") + "/api";
              _this.$router.push({ name: "Home" });
            })
            .catch((error) => {
              $(".response-alert").prepend(
                $(
                  '<div class="alert alert-danger alert-dismissible fade show" role="alert">\n' +
                    "    The OTP entered is incorrect. Please try again.\n" +
                    '    <button type="button" class="close" data-dismiss="alert" aria-label="Close">\n' +
                    '       <span aria-hidden="true">&times;</span>\n' +
                    "    </button>\n" +
                    "</div>"
                )
              );
            })
            .finally(() => {
              _this.is_loading = false;
              _this.is_disabled = false;
              setTimeout(() => {
                $(".alert").fadeOut("slow");
              }, 5000);
            });
        }
      });
    },
  },
  mounted: function () {
    this.user.username = LocalStorage.get("userEmail");
    this.user.password = LocalStorage.get("userPassword");
  },
  created() {
    this.$emit("update:layout", GuestLayout);
  },
};
</script>
